import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Perfil</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Perfil</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Situação", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "form-group col-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Nome "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_16 = { class: "form-group col-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Observações "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_18 = { class: "card-footer text-center" }
const _hoisted_19 = { class: "btn-group" }
const _hoisted_20 = { class: "card card-success card-outline" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }),
    /*#__PURE__*/_createTextVNode(" Permissões ")
  ])
], -1)
const _hoisted_22 = { class: "card-body row body-table-list" }
const _hoisted_23 = { class: "table-list" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Módulo"),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Ler"),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Incluir"),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Editar"),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Excluir"),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} })
], -1)
const _hoisted_25 = { style: {"text-align":"center"} }
const _hoisted_26 = { class: "icheck-primary d-inline" }
const _hoisted_27 = ["onUpdate:modelValue", "id"]
const _hoisted_28 = ["for"]
const _hoisted_29 = { style: {"text-align":"center"} }
const _hoisted_30 = { class: "icheck-primary d-inline" }
const _hoisted_31 = ["onUpdate:modelValue", "id"]
const _hoisted_32 = ["for"]
const _hoisted_33 = { style: {"text-align":"center"} }
const _hoisted_34 = { class: "icheck-primary d-inline col-6 col-md-3" }
const _hoisted_35 = ["onUpdate:modelValue", "id"]
const _hoisted_36 = ["for"]
const _hoisted_37 = { style: {"text-align":"center"} }
const _hoisted_38 = { class: "icheck-primary d-inline col-6 col-md-3" }
const _hoisted_39 = ["onUpdate:modelValue", "id"]
const _hoisted_40 = ["for"]

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, "Perfil | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.enabled,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.enabled) = $event)),
                "on-label": "Ativo",
                "off-label": "Inativo",
                class: "toggle-enabled"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                id: "name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.row.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                maxlength: "100"
              }, null, 2), [
                [_vModelText, _ctx.row.name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.name), 513), [
                [_vShow, _ctx.errors.name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("textarea", {
                id: "description",
                rows: "4",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.row.description) = $event)),
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.description }])
              }, null, 2), [
                [_vModelText, _ctx.row.description]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.description), 513), [
                [_vShow, _ctx.errors.description != null]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-warning",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.goBack()))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-success",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.save()))
              }, "Gravar")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("table", _hoisted_23, [
              _hoisted_24,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemModuleProfile, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i.module
                }, [
                  _createElementVNode("td", null, _toDisplayString(i.module_description), 1),
                  _createElementVNode("td", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": $event => ((i.enabled_read) = $event),
                        id: i.module + 'read',
                        value: true
                      }, null, 8, _hoisted_27), [
                        [_vModelCheckbox, i.enabled_read]
                      ]),
                      _createElementVNode("label", {
                        for: i.module + 'read',
                        style: {"color":"#fff"}
                      }, ".", 8, _hoisted_28)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": $event => ((i.enabled_create) = $event),
                        id: i.module + 'create',
                        value: true
                      }, null, 8, _hoisted_31), [
                        [_vModelCheckbox, i.enabled_create]
                      ]),
                      _createElementVNode("label", {
                        for: i.module + 'create',
                        style: {"color":"#fff"}
                      }, ".", 8, _hoisted_32)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": $event => ((i.enabled_edit) = $event),
                        id: i.module + 'edit',
                        value: true
                      }, null, 8, _hoisted_35), [
                        [_vModelCheckbox, i.enabled_edit]
                      ]),
                      _createElementVNode("label", {
                        for: i.module + 'edit',
                        style: {"color":"#fff"}
                      }, ".", 8, _hoisted_36)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": $event => ((i.enabled_delete) = $event),
                        id: i.module + 'delete',
                        value: true
                      }, null, 8, _hoisted_39), [
                        [_vModelCheckbox, i.enabled_delete]
                      ]),
                      _createElementVNode("label", {
                        for: i.module + 'delete',
                        style: {"color":"#fff"}
                      }, ".", 8, _hoisted_40)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}